import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "upload"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_uploader = _resolveComponent("van-uploader");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_uploader, _mergeProps({
    modelValue: _ctx.fileList,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.fileList = $event),
    style: {
      "margin-left": "7px"
    },
    ref: "upload",
    accept: "image/*",
    "max-count": 1,
    "max-size": _ctx.maxSize * 1024 * 1024,
    "before-read": _ctx.beforeRead,
    "after-read": _ctx.afterRead
  }, _ctx.$attrs, {
    onOversize: _ctx.onOversize
  }), null, 16, ["modelValue", "max-size", "before-read", "after-read", "onOversize"])]);
}